module.exports = __webpack_public_path__ + "img/menu_down.6eb78d4e.svg";